import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { StripeOnboardingRouter } from "./Router";

export function StripeOnboardingContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <StripeOnboardingRouter />
    </ThemeProvider>
  );
}
